/*
 * Shared DataGrid cells for the Customer Details hierarchy.
 */
import React from "react"
import { ChevronDownIcon, ChevronRightIcon } from "@chakra-ui/icons"
import { Box, Flex, IconButton, Spinner, Text } from "@chakra-ui/react"
import { Chip } from "@mui/material"

export const SerialExpandCell = ({
  row,
  value,
  expandedCustomerId,
  expandedTrunkId,
  loadingTrunks,
  onCustomerToggle,
  onTrunkToggle,
}) => {
  const isCustomer = row?.hierarchyLevel === 0 && !row?.isLoadingRow
  const isTrunk = row?.hierarchyLevel === 1 && !row?.isLoadingRow && row?.canExpand
  const trunkKey = `${row?.customerId}:${row?.accountId}`
  const isCustomerExpanded = expandedCustomerId === row.customerId
  const isTrunkExpanded = expandedTrunkId === trunkKey
  const isTrunkLoading = Boolean(loadingTrunks?.[trunkKey])

  if (row?.isTotalRow) {
    return (
      <Flex align="center" justify="center" width="100%">
        <Text as="span" textAlign="center" width="100%">
          {value}
        </Text>
      </Flex>
    )
  }

  return (
    <Flex align="center" justify="center" width="100%" gap="6px">
      <Text as="span" minW="28px" textAlign={row?.isTotalRow ? "center" : "right"}>
        {isCustomer || row?.hierarchyLevel === 1 || row?.isTotalRow ? value : ""}
      </Text>
      {isCustomer ? (
        <IconButton
          size="xs"
          variant="ghost"
          icon={isCustomerExpanded ? <ChevronDownIcon /> : <ChevronRightIcon />}
          onClick={event => {
            event.stopPropagation()
            onCustomerToggle(row.customerId)
          }}
          aria-label={isCustomerExpanded ? "Collapse" : "Expand"}
          minW="24px"
          h="24px"
          _focus={{ boxShadow: "none" }}
          _active={{ bg: "transparent" }}
        />
      ) : isTrunk ? (
        <IconButton
          size="xs"
          variant="ghost"
          icon={
            isTrunkLoading ? (
              <Spinner size="xs" />
            ) : isTrunkExpanded ? (
              <ChevronDownIcon />
            ) : (
              <ChevronRightIcon />
            )
          }
          onClick={event => {
            event.stopPropagation()
            if (!isTrunkLoading) onTrunkToggle(row.customerId, row.accountId)
          }}
          aria-label={isTrunkExpanded ? "Collapse" : "Expand"}
          isDisabled={isTrunkLoading}
          minW="24px"
          h="24px"
          _focus={{ boxShadow: "none" }}
          _active={{ bg: "transparent" }}
        />
      ) : (
        <Box minW="24px" h="24px" />
      )}
    </Flex>
  )
}

export const ReportNameCell = ({ row, value }) => (
  <Flex
    align="center"
    justify="center"
    width="100%"
    height="100%"
    pl={`${(row?.hierarchyLevel ?? 0) * 24}px`}
    gap="6px"
  >
    {row?.isLoadingRow ? (
      <Spinner size="xs" />
    ) : (
      <Text as="span" noOfLines={1} textAlign="center">
        {value}
      </Text>
    )}
  </Flex>
)

export const DlrCell = ({ value }) => {
  if (value === "-" || value === "" || value == null) return value ?? ""

  const numeric = parseFloat(value)
  const bg = numeric >= 85 ? "#22c55e" : numeric >= 50 ? "#f59e0b" : "#ef4444"

  return (
    <Chip
      label={value ?? "-"}
      size="small"
      sx={{
        backgroundColor: `${bg} !important`,
        color: "white !important",
        fontWeight: 500,
        fontSize: "11px",
      }}
    />
  )
}
